import * as angular from 'angular';

"use strict";

angular.module('GridModule', [])

export default 'GridModule';